import Vue from 'vue';
import storage from '../../models/storage'
import $bizConfig from '@/models/bizConfig'

const Web3 = require('web3')

let web3 = undefined;
let web3Main = undefined;
let currWalletAddress = undefined;
let connectedMainNetwork = false;
let connectedNetwork = "";
let connectedChainId = null;
let approvalEventSignature = "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925";
let currWalletType = undefined;

const initWeb3 = async() => {

    let web3Provider
    let ethereum = window.ethereum;
    if (ethereum) {

        let connectedMetaMask = await connectMetaMask();
        if (connectedMetaMask) {

            await getNetwork();
        }
        // else {
        //     // alert(window.web3);
        //     web3 = new Web3(window.web3.currentProvider)
        // }
    } else if (window.web3) {
        web3Provider = window.web3.currentProvider
        if (typeof web3Provider !== 'undefined') {
            web3 = new Web3(web3Provider)
                // console.log('Connected wallet success!')
        } else {
            // console.log('Connected wallet failed!')
        }
    }
    if (!web3) {

        // set the provider you want from Web3.providers
        // web3 = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"));
        let HOST = process.env.HOST;
        if (!!HOST && ("test" == HOST.toLowerCase() || "dev" == HOST.toLowerCase())) {
            //web3 = new Web3(new Web3.providers.HttpProvider("https://data-seed-prebsc-2-s3.binance.org:8545"));
            web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org"));
        } else {
            web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org"));
        }
        if (!!HOST && ("test" == HOST.toLowerCase() || "dev" == HOST.toLowerCase())) {
            web3Main = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org"));
        } else {
            web3Main = web3
        }
        // window.web3 = web3Main;
        await getNetwork();
    }
}

const getNetwork = async() => {
    if (!web3 || !web3.eth) {
        connectedMainNetwork = false;
        connectedNetwork = "";
        connectedChainId = null;
        return connectedChainId;
    }
    connectedChainId = await web3.eth.net.getId();
    // console.log('connectedChainId',connectedChainId)
    if (connectedChainId === 1) {
        connectedMainNetwork = true;
        connectedNetwork = "Main";
    } else if (connectedChainId === 3) {
        connectedNetwork = "Ropsten";
    } else if (connectedChainId === 4) {
        connectedNetwork = "Rinkeby";
    } else if (connectedChainId === 5) {
        connectedNetwork = "Goerli";
    } else if (connectedChainId === 42) {
        connectedNetwork = "Kovan";
    } else if (connectedChainId === 128) {
        connectedNetwork = "HECO Main";
    } else if (connectedChainId === 256) {
        connectedNetwork = "HECO TEST";
    } else if (connectedChainId === 56) {
        connectedNetwork = "BSC Main";
    } else if (connectedChainId === 97) {
        connectedNetwork = "BSC TEST";
    } else {
        connectedMainNetwork = false;
        connectedNetwork = "";
    }
    return connectedChainId;
}

const connectMetaMask = async() => {
    return new Promise((resolve, reject) => {
        let web3Provider
        let ethereum = window.ethereum;
        if (ethereum) {
            web3Provider = ethereum;
            try {
                // user auth
                if (ethereum.request != undefined) {
                    ethereum.request({ method: 'eth_requestAccounts' });
                } else {
                    ethereum.enable();
                }
                resolve(true);
            } catch (error) {
                // user not auth
                reject(error && error.message ? error.message : error);
            }
        } else {
            reject("No Ethereum");
        }

        if (typeof web3Provider !== 'undefined') {
            web3 = new Web3(web3Provider)
            if (ethereum.isMetaMask) {
                currWalletType = "MetaMask";
            } else {
                currWalletType = "Ethereum";
            }
            let HOST = process.env.HOST;
            if (!!HOST && ("test" == HOST.toLowerCase() || "dev" == HOST.toLowerCase())) {
                web3Main = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org"));
            } else {
                web3Main = web3
            }
        }
    })
}

const connectWallet = () => {

    return new Promise((resolve, reject) => {
        if (storage.get('wrongNetWork') == 'true' || storage.get('wrongNetWork') == undefined) {
            currWalletAddress = undefined;
            reject("no wallet")
            return
        }
        if (web3 == undefined) {
            currWalletAddress = undefined;
            reject("no wallet")
            return;
        }
        web3.eth.getAccounts().then(accounts => {
            if (accounts.length > 0) {
                currWalletAddress = accounts[0];
                // currWalletAddress = "0x0e1ac7095bdcad5e987d00e65f76098332dcda1d";
                // alert(currWalletAddress)
                showTipsOnce();
            } else {
                currWalletAddress = undefined;
            }


            resolve(currWalletAddress)
        }).catch((err) => {
            currWalletAddress = undefined;
            // console.error('web3.eth.getAccounts error :' + err)
            reject(err)
        })
    })
}
const showTipsOnce = ()=>{
    var timestamp = Date.parse(new Date());
    if(timestamp>1642003199000)return;
    //1641553607558  1641830399000
    //1641830400000  1641916799000
    //1641916800000  1642003199000
    let isTipsOnce = Vue.prototype.$storage.get('TipsOnce');
    if(timestamp>1641553607558&&timestamp<1641830399000){
        if(isTipsOnce&&isTipsOnce==1)return;
        Vue.prototype.$storage.set('TipsOnce',1);
        Vue.prototype.$eventHub.$emit('showTipsOnce');
    }
    if(timestamp>1641830400000&&timestamp<1641916799000){
        if(isTipsOnce&&isTipsOnce==2)return;
        Vue.prototype.$storage.set('TipsOnce',2);
        Vue.prototype.$eventHub.$emit('showTipsOnce');
    }
    if(timestamp>1641916800000&&timestamp<1642003199000){
        if(isTipsOnce&&isTipsOnce==3)return;
        Vue.prototype.$storage.set('TipsOnce',3);
        Vue.prototype.$eventHub.$emit('showTipsOnce');
    }
}

const handleCallReject = (reject, error) => {
    let nodeError = String(error).indexOf("header not found") != -1;
    let nodeError2 = String(error).indexOf("Access-Control-Allow-Origin") != -1;
    if (!nodeError && !nodeError2) {
        reject(error);
    }
}

const commonCall = (method, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).call({ from: currWalletAddress }).then(result => {
            resolve(result);
        }).catch(error => {
            handleCallReject(reject, error);
        })
    })
}

const commonCallAndHandler = (method, handler, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).call({ from: currWalletAddress }).then(result => {
            resolve(handler(result));
        }).catch(error => {
            handleCallReject(reject, error);
        })
    })
}

const commonCallAndHandlerParams = (method, handler, handlerParams, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).call({ from: currWalletAddress }).then(result => {
            resolve(handler(result, ...handlerParams));
        }).catch(error => {
            handleCallReject(reject, error);
        })
    })
}

/**
 * result: transactionHash
 */
const commonSend = (method, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).send({ from: currWalletAddress }, function(error, result) {
            if (!error) {
                resolve(result)
            } else {
                reject(error)
            }
        })
    })
}

/**
 * result: {transactionHash: ""}
 */
const commonSendWithOptions = (method, options, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).send(Object.assign({ from: currWalletAddress }, options)).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error)
        })
    })
}

const commonEstimateGas = (method, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).estimateGas({ from: currWalletAddress }, function(error, result) {
            if (!error) {
                resolve(result)
            } else {
                reject(error)
            }
        })
    })
}

const commonEstimateGasWithOptions = (method, options, ...params) => {
    return new Promise((resolve, reject) => {
        method(...params).estimateGas(Object.assign({ from: currWalletAddress }, options)).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error)
        })
    })
}

const call = (method, params = [], options = {}, handler, handlerParams = []) => {
    return new Promise((resolve, reject) => {
        method(...params)
            .call({ from: currWalletAddress, ...options })
            .then((result) => {
                if (handler && typeof handler === 'function') {
                    resolve(handler(result, ...handlerParams));
                } else {
                    resolve(result);
                }
            }).catch((error) => {
                handleCallReject(reject, error);
            })
    })
}

const send = (method, params = [], options = {}, callback) => {
    method(...params)
        .send({ from: currWalletAddress, ...options })
        .on('transactionHash', (transactionHash) => {
            if (callback && callback.onTxSend && typeof callback.onTxSend === 'function') {
                callback.onTxSend(transactionHash);
            }
        })
        .on('confirmation', (confirmations, receipt, latestBlockHash) => {
            if (1 === confirmations) {
                if (callback && callback.onTxConfirmed && typeof callback.onTxConfirmed === 'function') {
                    callback.onTxConfirmed(receipt);
                }
            }
        })
        // .on('receipt', (receipt) => {
        //   console.log('receipt :>> ', receipt);
        // })
        .on('error', (error, receipt) => {
            if (callback && callback.onTxFailed && typeof callback.onTxFailed === 'function') {
                callback.onTxFailed(error, receipt);
            }
        });
}

const estimateSend = (method, params = [], options = {}) => {
    return new Promise((resolve, reject) => {
        method(...params)
            .estimateGas({ from: currWalletAddress, ...options })
            .then((result) => {
                resolve(result);
            }).catch(error => {
                reject(error)
            })
    })
}

const getBlockNumber = () => {
    return new Promise((resolve, reject) => {
        web3.eth.getBlockNumber().then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

const getEthBalance = (address) => {
    return new Promise((resolve, reject) => {
        web3.eth.getBalance(address).then(res => {
            resolve(fromWei(res))
        }).catch(error => {
            reject(error)
        })
    })
}

const getGasPrice = () => {
    return new Promise((resolve, reject) => {
        web3.eth.getGasPrice().then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * jsonParams {
 * from,
 * to,
 * gas,
 * gasPrice,
 * value,
 * data,
 * nonce
 * }
 */
const estimateGas = (jsonParams) => {
    return new Promise((resolve, reject) => {
        web3.eth.estimateGas(jsonParams).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

const sendTransaction = (jsonParams) => {
    return new Promise((resolve, reject) => {
        web3.eth.sendTransaction(jsonParams).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

const getTransaction = (_txid) => {
    return new Promise((resolve, reject) => {
        web3.eth.getTransaction(_txid).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

const getTransactionReceipt = (_txid) => {
    return new Promise((resolve, reject) => {
        web3.eth.getTransactionReceipt(_txid).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

const getCurrWalletAddress = () => {
    return !!currWalletAddress ? currWalletAddress.toLowerCase() : undefined;
}

const isMainNet = () => {
    return connectedMainNetwork;
}

const getConnectedNetwork = () => {
    return connectedNetwork;
}

const getConnectedChainId = () => {
    return connectedChainId;
}

const getWeb3 = () => {
    return web3;
}

const getWeb3Main = () => {
    return web3Main;
}

const getEth = () => {
    return !!web3 ? web3.eth : undefined;
}

const toBigNumber = (str) => {
    return web3.utils.toBigNumber(str);
}

const toWei = (number, unit) => {
    return web3.utils.toWei(number, unit);
}

const fromWei = (number, unit) => {
    return web3.utils.fromWei(number, unit);
}

const toChecksumAddress = () => {
    return web3.utils.toChecksumAddress(getCurrWalletAddress())
}

const signTypedData = (signer, data) => {
    return new Promise((resolve, reject) => {
        let params = [signer, data];
        let ethereum = window.ethereum;
        if (ethereum.request != undefined) {
            ethereum.request({ method: 'eth_signTypedData_v3', params }).then((result) => {
                    // console.log("error: " + result);
                    resolve(result)
                })
                .catch((error) => {
                    // console.log("error: " + error);
                    reject(error);
                });
        } else {
            web3.currentProvider.sendAsync({
                    method: "eth_signTypedData_v3",
                    params,
                    from: signer
                },
                (error, result) => {
                    if (!!result && !!result.result) {
                        resolve(result.result)
                    } else {
                        reject(!!error ? error : result.error);
                    }
                    // console.log("error: " + error);
                }
            );
        }
    });
}

const onEthereumEvent = async() => {
    let ethereum = window.ethereum;
    if (ethereum && ethereum.isMetaMask) {
        ethereum.on('accountsChanged', (accounts) => {
            // Handle the new accounts, or lack thereof.
            // "accounts" will always be an array, but it can be empty.
            Vue.prototype.$eventHub.$emit('walletChanged', null);
        });

        ethereum.on('chainChanged', async(chainId) => {
            // Handle the new chain.
            // Correctly handling chain changes can be complicated.
            // We recommend reloading the page unless you have a very good reason not to.
            // window.location.reload();
            let connectedChainId = await getNetwork();
            let activeChainId = $bizConfig.activeChainId;
            let wrongNetWork = activeChainId != connectedChainId;

            Vue.prototype.$eventHub.$emit('isWrongNetWork', wrongNetWork);
            storage.set("wrongNetWork", wrongNetWork);
            Vue.prototype.$eventHub.$emit('walletChanged', null);
        });

        ethereum.on('connect', (connectInfo) => {
            Vue.prototype.$eventHub.$emit('walletChanged', null);
        });

        ethereum.on('disconnect', (error) => {
            Vue.prototype.$eventHub.$emit('walletChanged', null);
        });
    }
}

const stringToBytes32 = (data) => {
    if (!String(data).startsWith("0x")) {
        data = web3.utils.utf8ToHex(data);
    }
    return web3.eth.abi.encodeParameter('bytes32', data);
}

const stringToHex = (data) => {
    if (!String(data).startsWith("0x")) {
        data = web3.utils.utf8ToHex(data);
    }
    return data;
}

const encodeFunctionCall = (jsonInterface, parameters) => {
    return web3.eth.abi.encodeFunctionCall(jsonInterface, parameters);
}

/**
 * @param {*} type  bytes32, bytes
 * @param {*} data
 * @returns
 */
const encodeParameter = (type, data) => {
    return web3.eth.abi.encodeParameter(type, data);
}

const encodeParameters = (typesArray, datasArray) => {
    return web3.eth.abi.encodeParameters(typesArray, datasArray);
}

const decodeParameter = (type, hexString) => {
    return web3.eth.abi.decodeParameter(type, hexString);
}

const decodeParameterReverse = (hexString, type) => {
    return web3.eth.abi.decodeParameter(type, hexString);
}

const decodeParameters = (typesArray, hexString) => {
    return web3.eth.abi.decodeParameters(typesArray, hexString);
}

const decodeParametersReverse = (typesArray, hexString) => {
    return web3.eth.abi.decodeParameters(typesArray, hexString);
}

const getMaxApprove = () => {
    // 9007199254740991
    return Number.MAX_SAFE_INTEGER;
}

const getApprovalEventSignature = () => {
    return approvalEventSignature;
}

const addEthereumChain = () => {
    let ethereum = window.ethereum;
    if (ethereum && ethereum.isMetaMask) {
        let activeChainId = $bizConfig.activeChainId;
        let params;
        if (activeChainId == 56) {
            params = [{
                "chainId": "0x38",
                "chainName": "BSC",
                "rpcUrls": ["https://bsc-dataseed.binance.org"],
                "nativeCurrency": {
                    "name": "BSC MAIN",
                    "symbol": "BSC",
                    "decimals": 18
                },
                "blockExplorerUrls": ["https://bscscan.com"]
            }];
        }
        if (activeChainId == 97) {
            params = [{
                "chainId": "0x61",
                "chainName": "BSC TEST",
                "rpcUrls": ["https://data-seed-prebsc-2-s3.binance.org:8545"],
                "nativeCurrency": {
                    "name": "BSC TEST",
                    "symbol": "BSC",
                    "decimals": 18
                },
                "blockExplorerUrls": ["https://testnet.bscscan.com"]
            }];
        }
        if (!!params) {
            ethereum.request({
                method: 'wallet_addEthereumChain',
                params: params
            });
        }
    }
}

const watchAssetDmc = (address) => {
    watchAssetErc20(address, "DMC", 18, "https://nftimg.s3-ap-southeast-1.amazonaws.com/coin/DMC.png");
}

const watchAssetErc20 = (address, symbol, decimals, image) => {
    watchAsset("ERC20", address, symbol, decimals, image);
}

const watchAsset = (type, address, symbol, decimals, image) => {
    let ethereum = window.ethereum;
    if (ethereum && ethereum.isMetaMask) {
        let params = {
            type: type,
            options: {
                address: address,
                symbol: symbol,
                decimals: decimals,
                image: image,
            },
        };
        ethereum.request({
            method: 'wallet_watchAsset',
            params: params
        });
    }
}

initWeb3();
onEthereumEvent();
addEthereumChain();
// watchAssetDmc("0x50a3d9cbb5615ed650ffa48da36ffa5cf82fcd79")

export default {
    initWeb3,
    connectMetaMask,
    connectWallet,
    addEthereumChain,
    // commonCall,
    // commonCallAndHandler,
    // commonCallAndHandlerParams,
    // commonSend,
    // commonSendWithOptions,
    // commonEstimateGas,
    // commonEstimateGasWithOptions,
    call,
    send,
    estimateSend,

    getNetwork,
    toChecksumAddress,
    signTypedData,
    getCurrWalletAddress,
    toBigNumber,
    toWei,
    fromWei,
    isMainNet,
    getConnectedNetwork,
    getConnectedChainId,
    getMaxApprove,
    getApprovalEventSignature,
    getWeb3,
    getWeb3Main,
    getEth,
    stringToBytes32,
    stringToHex,
    encodeFunctionCall,
    encodeParameter,
    encodeParameters,
    decodeParameter,
    decodeParameterReverse,
    decodeParameters,
    decodeParametersReverse,
    // eth
    estimateGas,
    sendTransaction,
    getBlockNumber,
    getEthBalance,
    getGasPrice,
    getTransaction,
    getTransactionReceipt,
}



// WEBPACK FOOTER //
// ./src/lib/contract/web3.js